export default __webpack_public_path__ + "static/media/Big-chicken.38f40071.svg";